var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404IllustrationXs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "379px",
    height: "301px",
    viewBox: "0 0 379 301",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "23.3865017%",
    y1: "7.15684517%",
    x2: "53.9409722%",
    y2: "57.3808711%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "31.4957682%",
    y1: "0%",
    x2: "43.5481771%",
    y2: "50%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "85.764622%",
    y1: "42.8340925%",
    x2: "24.2768159%",
    y2: "56.845399%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M199,34 C196.790861,34 195,32.209139 195,30 C195,27.790861 196.790861,26 199,26 C200.393644,26 201.620823,26.7127211 202.33693,27.7935553 C203.007639,26.1540312 204.61905,25 206.5,25 L206.30916,25.0044728 C207.229642,22.1106857 210.100726,20 213.5,20 C217.331015,20 220.49115,22.6808904 220.944259,26.1422696 C221.279795,26.0491126 221.634162,26 222,26 C224.209139,26 226,27.790861 226,30 C226,30.0924298 225.996865,30.1841273 225.990695,30.2749921 C226.285562,30.0998664 226.631119,30 227,30 C228.104569,30 229,30.8954305 229,32 C229,33.1045695 228.104569,34 227,34 L227,34 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.2%",
    y: "-39.3%",
    width: "132.4%",
    height: "178.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -5,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36,95 C33.790861,95 32,93.209139 32,91 C32,88.790861 33.790861,87 36,87 C37.3936442,87 38.6208234,87.7127211 39.3369298,88.7935553 C40.0076394,87.1540312 41.6190505,86 43.5,86 L43.3091598,86.0044728 C44.2296422,83.1106857 47.1007263,81 50.5,81 C54.3310152,81 57.4911495,83.6808904 57.9442586,87.1422696 C58.2797953,87.0491126 58.6341622,87 59,87 C61.209139,87 63,88.790861 63,91 C63,91.0924298 62.996865,91.1841273 62.9906955,91.2749921 C63.2855622,91.0998664 63.6311186,91 64,91 C65.1045695,91 66,91.8954305 66,93 C66,94.1045695 65.1045695,95 64,95 L64,95 Z",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.2%",
    y: "-39.3%",
    width: "132.4%",
    height: "178.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -5,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50%",
    fx: "48.9155431%",
    fy: "50%",
    r: "49.173591%",
    gradientTransform: "translate(0.489155,0.500000),scale(0.080382,1.000000),rotate(90.000000),scale(1.000000,13.366712),translate(-0.489155,-0.500000)",
    id: "radialGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "65.8958899%",
    y1: "35.5406621%",
    x2: "27.6520041%",
    y2: "71.7686607%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "3.061617e-15%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.692059,132.635724 C157.333726,132.635724 157.858726,133.160724 157.858726,133.802391 L157.858726,133.802391 L157.858726,135.351724 C158.926226,135.627057 159.933059,136.047057 160.859392,136.594224 L160.859392,136.594224 L161.953726,135.498724 C162.407559,135.044891 163.150726,135.044891 163.604559,135.498724 L163.604559,135.498724 L166.079059,137.973224 C166.532892,138.427057 166.532892,139.170224 166.079059,139.624057 L166.079059,139.624057 L164.983559,140.718391 C165.530726,141.644724 165.950726,142.651557 166.226059,143.719057 L166.226059,143.719057 L167.775392,143.719057 C168.417059,143.719057 168.942059,144.244057 168.942059,144.885724 L168.942059,144.885724 L168.942059,148.385724 C168.942059,149.027391 168.417059,149.552391 167.775392,149.552391 L167.775392,149.552391 L166.226059,149.552391 C165.950726,150.619891 165.530726,151.626724 164.983559,152.553057 L164.983559,152.553057 L166.079059,153.647391 C166.532892,154.101224 166.532892,154.844391 166.079059,155.298224 L166.079059,155.298224 L163.604559,157.772724 C163.150726,158.226557 162.407559,158.226557 161.953726,157.772724 L161.953726,157.772724 L160.859392,156.677224 C159.933059,157.224391 158.926226,157.644391 157.858726,157.919724 L157.858726,157.919724 L157.858726,159.469057 C157.858726,160.110724 157.333726,160.635724 156.692059,160.635724 L156.692059,160.635724 L153.192059,160.635724 C152.550392,160.635724 152.025392,160.110724 152.025392,159.469057 L152.025392,159.469057 L152.025392,157.919724 C150.957892,157.644391 149.951059,157.224391 149.024726,156.677224 L149.024726,156.677224 L147.930392,157.772724 C147.476559,158.226557 146.733392,158.226557 146.279559,157.772724 L146.279559,157.772724 L143.805059,155.298224 C143.351226,154.844391 143.351226,154.101224 143.805059,153.647391 L143.805059,153.647391 L144.900559,152.553057 C144.353392,151.626724 143.933392,150.619891 143.658059,149.552391 L143.658059,149.552391 L142.108726,149.552391 C141.467059,149.552391 140.942059,149.027391 140.942059,148.385724 L140.942059,148.385724 L140.942059,144.885724 C140.942059,144.244057 141.467059,143.719057 142.108726,143.719057 L142.108726,143.719057 L143.658059,143.719057 C143.933392,142.651557 144.353392,141.644724 144.900559,140.718391 L144.900559,140.718391 L143.805059,139.624057 C143.351226,139.170224 143.351226,138.427057 143.805059,137.973224 L143.805059,137.973224 L146.279559,135.498724 C146.733392,135.044891 147.476559,135.044891 147.930392,135.498724 L147.930392,135.498724 L149.024726,136.594224 C149.951059,136.047057 150.957892,135.627057 152.025392,135.351724 L152.025392,135.351724 L152.025392,133.802391 C152.025392,133.160724 152.550392,132.635724 153.192059,132.635724 L153.192059,132.635724 Z M154.442059,141.635724 C151.956778,141.635724 149.942059,143.650443 149.942059,146.135724 C149.942059,148.621005 151.956778,150.635724 154.442059,150.635724 C156.92734,150.635724 158.942059,148.621005 158.942059,146.135724 C158.942059,143.650443 156.92734,141.635724 154.442059,141.635724 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-7.1%",
    y: "-7.1%",
    width: "114.3%",
    height: "114.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-12"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.437854,167.685624 C128.537854,167.685624 129.437854,168.585624 129.437854,169.685624 L129.437854,169.685624 L129.437854,172.341624 C131.267854,172.813624 132.993854,173.533624 134.581854,174.471624 L134.581854,174.471624 L136.457854,172.593624 C137.235854,171.815624 138.509854,171.815624 139.287854,172.593624 L139.287854,172.593624 L143.529854,176.835624 C144.307854,177.613624 144.307854,178.887624 143.529854,179.665624 L143.529854,179.665624 L141.651854,181.541624 C142.589854,183.129624 143.309854,184.855624 143.781854,186.685624 L143.781854,186.685624 L146.437854,186.685624 C147.537854,186.685624 148.437854,187.585624 148.437854,188.685624 L148.437854,188.685624 L148.437854,194.685624 C148.437854,195.785624 147.537854,196.685624 146.437854,196.685624 L146.437854,196.685624 L143.781854,196.685624 C143.309854,198.515624 142.589854,200.241624 141.651854,201.829624 L141.651854,201.829624 L143.529854,203.705624 C144.307854,204.483624 144.307854,205.757624 143.529854,206.535624 L143.529854,206.535624 L139.287854,210.777624 C138.509854,211.555624 137.235854,211.555624 136.457854,210.777624 L136.457854,210.777624 L134.581854,208.899624 C132.993854,209.837624 131.267854,210.557624 129.437854,211.029624 L129.437854,211.029624 L129.437854,213.685624 C129.437854,214.785624 128.537854,215.685624 127.437854,215.685624 L127.437854,215.685624 L121.437854,215.685624 C120.337854,215.685624 119.437854,214.785624 119.437854,213.685624 L119.437854,213.685624 L119.437854,211.029624 C117.607854,210.557624 115.881854,209.837624 114.293854,208.899624 L114.293854,208.899624 L112.417854,210.777624 C111.639854,211.555624 110.365854,211.555624 109.587854,210.777624 L109.587854,210.777624 L105.345854,206.535624 C104.567854,205.757624 104.567854,204.483624 105.345854,203.705624 L105.345854,203.705624 L107.223854,201.829624 C106.285854,200.241624 105.565854,198.515624 105.093854,196.685624 L105.093854,196.685624 L102.437854,196.685624 C101.337854,196.685624 100.437854,195.785624 100.437854,194.685624 L100.437854,194.685624 L100.437854,188.685624 C100.437854,187.585624 101.337854,186.685624 102.437854,186.685624 L102.437854,186.685624 L105.093854,186.685624 C105.565854,184.855624 106.285854,183.129624 107.223854,181.541624 L107.223854,181.541624 L105.345854,179.665624 C104.567854,178.887624 104.567854,177.613624 105.345854,176.835624 L105.345854,176.835624 L109.587854,172.593624 C110.365854,171.815624 111.639854,171.815624 112.417854,172.593624 L112.417854,172.593624 L114.293854,174.471624 C115.881854,173.533624 117.607854,172.813624 119.437854,172.341624 L119.437854,172.341624 L119.437854,169.685624 C119.437854,168.585624 120.337854,167.685624 121.437854,167.685624 L121.437854,167.685624 Z M124.437854,183.685624 C120.019576,183.685624 116.437854,187.267346 116.437854,191.685624 C116.437854,196.103902 120.019576,199.685624 124.437854,199.685624 C128.856132,199.685624 132.437854,196.103902 132.437854,191.685624 C132.437854,187.267346 128.856132,183.685624 124.437854,183.685624 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.5%",
    y: "-7.3%",
    width: "127.1%",
    height: "129.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-14"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.028721,143.612202 L172.171192,156.04947 C181.0696,158.132021 187.587372,165.748137 188.270232,174.861445 C188.921272,183.550098 182.873643,191.314969 174.290081,192.8113 L116.889768,202.817619 C100.541097,205.667604 84.9775126,194.724758 82.1275279,178.376087 C81.7707797,176.329635 81.6272062,174.251704 81.6991109,172.175634 C82.280582,155.387102 96.3617511,142.248684 113.150283,142.830155 C115.130557,142.898742 117.099392,143.160669 119.028721,143.612202 Z",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.8%",
    y: "2.9%",
    width: "109.8%",
    height: "99.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-16"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.2,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.423233696   0 0 0 0 0.423233696   0 0 0 0 0.423233696  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-17",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 109,
    height: 74,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219.625,145 C221.320833,145 222.708333,146.3875 222.708333,148.083333 L222.708333,148.083333 L222.708333,152.178 C225.529583,152.905667 228.1905,154.015667 230.638667,155.46175 L230.638667,155.46175 L233.530833,152.5665 C234.73025,151.367083 236.694333,151.367083 237.89375,152.5665 L237.89375,152.5665 L244.4335,159.10625 C245.632917,160.305667 245.632917,162.26975 244.4335,163.469167 L244.4335,163.469167 L241.53825,166.361333 C242.984333,168.8095 244.094333,171.470417 244.822,174.291667 L244.822,174.291667 L248.916667,174.291667 C250.6125,174.291667 252,175.679167 252,177.375 L252,177.375 L252,186.625 C252,188.320833 250.6125,189.708333 248.916667,189.708333 L248.916667,189.708333 L244.822,189.708333 C244.094333,192.529583 242.984333,195.1905 241.53825,197.638667 L241.53825,197.638667 L244.4335,200.530833 C245.632917,201.73025 245.632917,203.694333 244.4335,204.89375 L244.4335,204.89375 L237.89375,211.4335 C236.694333,212.632917 234.73025,212.632917 233.530833,211.4335 L233.530833,211.4335 L230.638667,208.53825 C228.1905,209.984333 225.529583,211.094333 222.708333,211.822 L222.708333,211.822 L222.708333,215.916667 C222.708333,217.6125 221.320833,219 219.625,219 L219.625,219 L210.375,219 C208.679167,219 207.291667,217.6125 207.291667,215.916667 L207.291667,215.916667 L207.291667,211.822 C204.470417,211.094333 201.8095,209.984333 199.361333,208.53825 L199.361333,208.53825 L196.469167,211.4335 C195.26975,212.632917 193.305667,212.632917 192.10625,211.4335 L192.10625,211.4335 L185.5665,204.89375 C184.367083,203.694333 184.367083,201.73025 185.5665,200.530833 L185.5665,200.530833 L188.46175,197.638667 C187.015667,195.1905 185.905667,192.529583 185.178,189.708333 L185.178,189.708333 L181.083333,189.708333 C179.3875,189.708333 178,188.320833 178,186.625 L178,186.625 L178,177.375 C178,175.679167 179.3875,174.291667 181.083333,174.291667 L181.083333,174.291667 L185.178,174.291667 C185.905667,171.470417 187.015667,168.8095 188.46175,166.361333 L188.46175,166.361333 L185.5665,163.469167 C184.367083,162.26975 184.367083,160.305667 185.5665,159.10625 L185.5665,159.10625 L192.10625,152.5665 C193.305667,151.367083 195.26975,151.367083 196.469167,152.5665 L196.469167,152.5665 L199.361333,155.46175 C201.8095,154.015667 204.470417,152.905667 207.291667,152.178 L207.291667,152.178 L207.291667,148.083333 C207.291667,146.3875 208.679167,145 210.375,145 L210.375,145 Z M214.5,169 C207.596441,169 202,174.596441 202,181.5 C202,188.403559 207.596441,194 214.5,194 C221.403559,194 227,188.403559 227,181.5 C227,174.596441 221.403559,169 214.5,169 Z",
    id: "path-18"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.8%",
    y: "-4.7%",
    width: "117.6%",
    height: "118.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-19"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-20",
    cx: 350,
    cy: 40,
    r: 13
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-23.1%",
    y: "-23.1%",
    width: "192.3%",
    height: "184.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-21"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 6,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "39.5617232%",
    y1: "0%",
    x2: "62.1942748%",
    y2: "100%",
    id: "linearGradient-22"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    stopOpacity: 0.25,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-23",
    cx: 292,
    cy: 202.7894,
    rx: 1.74326923,
    ry: 1.7228145
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-57.4%",
    y: "-58.0%",
    width: "214.7%",
    height: "216.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-24"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "60.9973917%",
    y1: "100%",
    x2: "39.3363291%",
    y2: "0%",
    id: "linearGradient-25"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50.9384395%",
    fx: "48.9155431%",
    fy: "50.9384395%",
    r: "48.2351515%",
    gradientTransform: "translate(0.489155,0.509384),scale(0.078113,1.000000),rotate(90.000000),scale(1.000000,13.555189),translate(-0.489155,-0.509384)",
    id: "radialGradient-26"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M294.6875,228 C295.489583,228 296.145833,228.65625 296.145833,229.458333 L296.145833,229.458333 L296.145833,231.395 C297.480208,231.739167 298.73875,232.264167 299.896667,232.948125 L299.896667,232.948125 L301.264583,231.57875 C301.831875,231.011458 302.760833,231.011458 303.328125,231.57875 L303.328125,231.57875 L306.42125,234.671875 C306.988542,235.239167 306.988542,236.168125 306.42125,236.735417 L306.42125,236.735417 L305.051875,238.103333 C305.735833,239.26125 306.260833,240.519792 306.605,241.854167 L306.605,241.854167 L308.541667,241.854167 C309.34375,241.854167 310,242.510417 310,243.3125 L310,243.3125 L310,247.6875 C310,248.489583 309.34375,249.145833 308.541667,249.145833 L308.541667,249.145833 L306.605,249.145833 C306.260833,250.480208 305.735833,251.73875 305.051875,252.896667 L305.051875,252.896667 L306.42125,254.264583 C306.988542,254.831875 306.988542,255.760833 306.42125,256.328125 L306.42125,256.328125 L303.328125,259.42125 C302.760833,259.988542 301.831875,259.988542 301.264583,259.42125 L301.264583,259.42125 L299.896667,258.051875 C298.73875,258.735833 297.480208,259.260833 296.145833,259.605 L296.145833,259.605 L296.145833,261.541667 C296.145833,262.34375 295.489583,263 294.6875,263 L294.6875,263 L290.3125,263 C289.510417,263 288.854167,262.34375 288.854167,261.541667 L288.854167,261.541667 L288.854167,259.605 C287.519792,259.260833 286.26125,258.735833 285.103333,258.051875 L285.103333,258.051875 L283.735417,259.42125 C283.168125,259.988542 282.239167,259.988542 281.671875,259.42125 L281.671875,259.42125 L278.57875,256.328125 C278.011458,255.760833 278.011458,254.831875 278.57875,254.264583 L278.57875,254.264583 L279.948125,252.896667 C279.264167,251.73875 278.739167,250.480208 278.395,249.145833 L278.395,249.145833 L276.458333,249.145833 C275.65625,249.145833 275,248.489583 275,247.6875 L275,247.6875 L275,243.3125 C275,242.510417 275.65625,241.854167 276.458333,241.854167 L276.458333,241.854167 L278.395,241.854167 C278.739167,240.519792 279.264167,239.26125 279.948125,238.103333 L279.948125,238.103333 L278.57875,236.735417 C278.011458,236.168125 278.011458,235.239167 278.57875,234.671875 L278.57875,234.671875 L281.671875,231.57875 C282.239167,231.011458 283.168125,231.011458 283.735417,231.57875 L283.735417,231.57875 L285.103333,232.948125 C286.26125,232.264167 287.519792,231.739167 288.854167,231.395 L288.854167,231.395 L288.854167,229.458333 C288.854167,228.65625 289.510417,228 290.3125,228 L290.3125,228 Z M292.5,239.666667 C289.278339,239.666667 286.666667,242.278339 286.666667,245.5 C286.666667,248.721661 289.278339,251.333333 292.5,251.333333 C295.721661,251.333333 298.333333,248.721661 298.333333,245.5 C298.333333,242.278339 295.721661,239.666667 292.5,239.666667 Z",
    id: "path-27"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-10.2%",
    y: "-10.0%",
    width: "120.4%",
    height: "131.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-28"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M210.306416,163.197974 L311.219982,184.177585 C324.035077,186.841803 333.575824,197.611022 334.675998,210.65381 C335.720396,223.035355 327.006111,234.114041 314.726951,236.015528 L212.893516,251.784926 C188.990108,255.486484 166.611861,239.109648 162.910303,215.20624 C162.479675,212.425388 162.318057,209.609505 162.42769,206.797645 L162.676114,200.426151 C163.528191,178.57228 181.935,161.546962 203.788871,162.39904 C205.979757,162.484462 208.159765,162.751692 210.306416,163.197974 Z",
    id: "path-29"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.5%",
    y: "3.0%",
    width: "105.2%",
    height: "96.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-30"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.8,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.423233696   0 0 0 0 0.423233696   0 0 0 0 0.423233696  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-31",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 176.174046,
    height: 106.245801,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-29"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-32",
    cx: 161,
    cy: 277,
    r: 30
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-10.0%",
    y: "-10.0%",
    width: "140.0%",
    height: "136.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-33"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 6,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-34",
    cx: 58,
    cy: 42,
    r: 13
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-23.1%",
    y: "-23.1%",
    width: "192.3%",
    height: "184.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-35"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 6,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "85.764622%",
    y1: "42.7338712%",
    x2: "24.2768159%",
    y2: "56.9411377%",
    id: "linearGradient-36"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M317,94 L316.999812,93.8999437 C314.717665,93.4366008 313,91.4188915 313,89 C313,86.2385763 315.238576,84 318,84 C319.500062,84 320.845838,84.6605785 321.7623,85.7067071 C322.717757,84.0868651 324.481953,83 326.5,83 C326.797396,83 327.08928,83.0236039 327.373879,83.0690406 C328.480274,79.5594779 331.923656,77 336,77 C340.475356,77 344.187769,80.0850684 344.883069,84.1262647 C345.241405,84.0433698 345.615638,84 346,84 C348.761424,84 351,86.2385763 351,89 C351,89.0168215 350.999917,89.0336237 350.999751,89.050406 C351.161255,89.017246 351.328614,89 351.5,89 C352.880712,89 354,90.1192881 354,91.5 C354,92.8807119 352.880712,94 351.5,94 C351.32897,94 351.161951,93.9828256 351.000574,93.9501074 L351,94 L317,94 Z M341.92465,91.897495 L341.819534,91.9841711 C341.812597,91.98973 341.805651,91.9952792 341.798696,92.0008186 L342.000535,92.0011995 C341.974808,91.9669696 341.94951,91.9323988 341.92465,91.897495 Z",
    id: "path-37"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.4%",
    y: "-32.4%",
    width: "126.8%",
    height: "164.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-38"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -5,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(-4.000000, -16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.205727,16.1965036 C309.346204,15.3727934 312.606501,17.2153593 313.447989,20.2894876 L313.447989,20.2894876 L315.474124,27.7071772 C320.923873,27.6541511 326.404685,28.3468104 331.785223,29.8111326 L331.785223,29.8111326 L335.70946,23.1577529 C337.334709,20.4022115 340.96765,19.4493334 343.782664,21.0402459 L343.782664,21.0402459 L359.137409,29.7177313 C361.952296,31.3088632 362.92574,34.8650527 361.300491,37.620594 L361.300491,37.620594 L357.376254,44.2739738 C361.362033,48.1030515 364.715246,52.4029649 367.393208,57.0493893 L367.393208,57.0493893 L374.968828,55.0581578 C378.109305,54.2344476 381.369602,56.0770135 382.21109,59.1511418 L382.21109,59.1511418 L386.799255,75.9126484 C387.640743,78.9867767 385.75841,82.1781945 382.617934,83.0019047 L382.617934,83.0019047 L375.04015,84.9852337 C375.09432,90.3198478 374.386712,95.6848672 372.890785,100.951732 L372.890785,100.951732 L379.687763,104.793063 C382.502777,106.383975 383.476221,109.940165 381.851189,112.695831 L381.851189,112.695831 L372.985978,127.725931 C371.36073,130.481473 367.727788,131.434351 364.912774,129.843438 L364.912774,129.843438 L358.115797,126.002108 C354.204077,129.90368 349.81136,133.186051 345.064653,135.807436 L345.064653,135.807436 L347.09886,143.223008 C347.940349,146.297136 346.058015,149.488554 342.917539,150.312264 L342.917539,150.312264 L325.794273,154.803496 C322.653796,155.627207 319.393499,153.784641 318.552011,150.710512 L318.552011,150.710512 L316.525876,143.292823 C311.076127,143.345849 305.595315,142.65319 300.214777,141.188867 L300.214777,141.188867 L296.29054,147.842247 C294.665291,150.597788 291.03235,151.550667 288.217336,149.959754 L288.217336,149.959754 L272.862591,141.282269 C270.047704,139.691137 269.07426,136.134947 270.699509,133.379406 L270.699509,133.379406 L274.623746,126.726026 C270.637967,122.896949 267.284754,118.597035 264.606792,113.950611 L264.606792,113.950611 L257.031172,115.941842 C253.890695,116.765552 250.630398,114.922986 249.78891,111.848858 L249.78891,111.848858 L245.200745,95.0873516 C244.359257,92.0132233 246.24159,88.8218055 249.382066,87.9980953 L249.382066,87.9980953 L256.95985,86.0147663 C256.90568,80.6801522 257.613288,75.3151328 259.109215,70.0482679 L259.109215,70.0482679 L252.312237,66.2069373 C249.497223,64.6160248 248.523779,61.0598353 250.148811,58.3041687 L250.148811,58.3041687 L259.014022,43.2740685 C260.63927,40.5185272 264.272212,39.5656491 267.087226,41.1565616 L267.087226,41.1565616 L273.884203,44.9978922 C277.795923,41.0963195 282.18864,37.8139493 286.935347,35.1925641 L286.935347,35.1925641 L284.90114,27.776992 C284.059651,24.7028638 285.941985,21.5114459 289.082461,20.6877357 L289.082461,20.6877357 Z M295.527175,73.9297271 C288.999174,84.9976795 292.87318,99.1502153 304.180009,105.540301 C315.486838,111.930386 329.944824,108.138225 336.472825,97.0702729 C343.000826,86.0023205 339.12682,71.8497847 327.819991,65.4596994 C316.513162,59.0696141 302.055176,62.8617747 295.527175,73.9297271 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-1)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2057272,16.1965036 C64.3462035,15.3727934 67.6065009,17.2153593 68.447989,20.2894876 L68.447989,20.2894876 L70.4741236,27.7071772 C75.9238733,27.6541511 81.4046845,28.3468104 86.7852227,29.8111326 L86.7852227,29.8111326 L90.7094597,23.1577529 C92.3347085,20.4022115 95.9676503,19.4493334 98.7826638,21.0402459 L98.7826638,21.0402459 L114.137409,29.7177313 C116.952296,31.3088632 117.92574,34.8650527 116.300491,37.620594 L116.300491,37.620594 L112.376254,44.2739738 C116.362033,48.1030515 119.715246,52.4029649 122.393208,57.0493893 L122.393208,57.0493893 L129.968828,55.0581578 C133.109305,54.2344476 136.369602,56.0770135 137.21109,59.1511418 L137.21109,59.1511418 L141.799255,75.9126484 C142.640743,78.9867767 140.75841,82.1781945 137.617934,83.0019047 L137.617934,83.0019047 L130.04015,84.9852337 C130.09432,90.3198478 129.386712,95.6848672 127.890785,100.951732 L127.890785,100.951732 L134.687763,104.793063 C137.502777,106.383975 138.476221,109.940165 136.851189,112.695831 L136.851189,112.695831 L127.985978,127.725931 C126.36073,130.481473 122.727788,131.434351 119.912774,129.843438 L119.912774,129.843438 L113.115797,126.002108 C109.204077,129.90368 104.81136,133.186051 100.064653,135.807436 L100.064653,135.807436 L102.09886,143.223008 C102.940349,146.297136 101.058015,149.488554 97.9175386,150.312264 L97.9175386,150.312264 L80.7942728,154.803496 C77.6537965,155.627207 74.3934991,153.784641 73.552011,150.710512 L73.552011,150.710512 L71.5258764,143.292823 C66.0761267,143.345849 60.5953155,142.65319 55.2147773,141.188867 L55.2147773,141.188867 L51.2905403,147.842247 C49.6652915,150.597788 46.0323497,151.550667 43.2173362,149.959754 L43.2173362,149.959754 L27.8625908,141.282269 C25.047704,139.691137 24.0742602,136.134947 25.699509,133.379406 L25.699509,133.379406 L29.623746,126.726026 C25.6379667,122.896949 22.2847539,118.597035 19.6067921,113.950611 L19.6067921,113.950611 L12.0311717,115.941842 C8.89069537,116.765552 5.63039798,114.922986 4.78890987,111.848858 L4.78890987,111.848858 L0.20074465,95.0873516 C-0.640743456,92.0132233 1.24159012,88.8218055 4.38206648,87.9980953 L4.38206648,87.9980953 L11.9598501,86.0147663 C11.9056796,80.6801522 12.6132884,75.3151328 14.1092146,70.0482679 L14.1092146,70.0482679 L7.31223673,66.2069373 C4.49722328,64.6160248 3.52377946,61.0598353 5.14881126,58.3041687 L5.14881126,58.3041687 L14.0140215,43.2740685 C15.6392703,40.5185272 19.2722121,39.5656491 22.0872255,41.1565616 L22.0872255,41.1565616 L28.8842035,44.9978922 C32.7959231,41.0963195 37.1886404,37.8139493 41.9353474,35.1925641 L41.9353474,35.1925641 L39.9011396,27.776992 C39.0596515,24.7028638 40.9419851,21.5114459 44.0824614,20.6877357 L44.0824614,20.6877357 Z M50.527175,73.9297271 C43.9991742,84.9976795 47.8731799,99.1502153 59.180009,105.540301 C70.486838,111.930386 84.9448242,108.138225 91.472825,97.0702729 C98.0008258,86.0023205 94.1268201,71.8497847 82.819991,65.4596994 C71.513162,59.0696141 57.0551758,62.8617747 50.527175,73.9297271 Z",
    id: "Combined-Shape-Copy-3",
    fill: "url(#linearGradient-1)",
    opacity: 0.5,
    transform: "translate(71.000000, 85.500000) scale(-1, 1) translate(-71.000000, -85.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,49 C202.933333,49 205.333333,51.4 205.333333,54.3333333 L205.333333,54.3333333 L205.333333,61.416 C210.213333,62.6746667 214.816,64.5946667 219.050667,67.096 L219.050667,67.096 L224.053333,62.088 C226.128,60.0133333 229.525333,60.0133333 231.6,62.088 L231.6,62.088 L242.912,73.4 C244.986667,75.4746667 244.986667,78.872 242.912,80.9466667 L242.912,80.9466667 L237.904,85.9493333 C240.405333,90.184 242.325333,94.7866667 243.584,99.6666667 L243.584,99.6666667 L250.666667,99.6666667 C253.6,99.6666667 256,102.066667 256,105 L256,105 L256,121 C256,123.933333 253.6,126.333333 250.666667,126.333333 L250.666667,126.333333 L243.584,126.333333 C242.325333,131.213333 240.405333,135.816 237.904,140.050667 L237.904,140.050667 L242.912,145.053333 C244.986667,147.128 244.986667,150.525333 242.912,152.6 L242.912,152.6 L231.6,163.912 C229.525333,165.986667 226.128,165.986667 224.053333,163.912 L224.053333,163.912 L219.050667,158.904 C214.816,161.405333 210.213333,163.325333 205.333333,164.584 L205.333333,164.584 L205.333333,171.666667 C205.333333,174.6 202.933333,177 200,177 L200,177 L184,177 C181.066667,177 178.666667,174.6 178.666667,171.666667 L178.666667,171.666667 L178.666667,164.584 C173.786667,163.325333 169.184,161.405333 164.949333,158.904 L164.949333,158.904 L159.946667,163.912 C157.872,165.986667 154.474667,165.986667 152.4,163.912 L152.4,163.912 L141.088,152.6 C139.013333,150.525333 139.013333,147.128 141.088,145.053333 L141.088,145.053333 L146.096,140.050667 C143.594667,135.816 141.674667,131.213333 140.416,126.333333 L140.416,126.333333 L133.333333,126.333333 C130.4,126.333333 128,123.933333 128,121 L128,121 L128,105 C128,102.066667 130.4,99.6666667 133.333333,99.6666667 L133.333333,99.6666667 L140.416,99.6666667 C141.674667,94.7866667 143.594667,90.184 146.096,85.9493333 L146.096,85.9493333 L141.088,80.9466667 C139.013333,78.872 139.013333,75.4746667 141.088,73.4 L141.088,73.4 L152.4,62.088 C154.474667,60.0133333 157.872,60.0133333 159.946667,62.088 L159.946667,62.088 L164.949333,67.096 C169.184,64.5946667 173.786667,62.6746667 178.666667,61.416 L178.666667,61.416 L178.666667,54.3333333 C178.666667,51.4 181.066667,49 184,49 L184,49 Z M191.5,91 C179.625878,91 170,100.625878 170,112.5 C170,124.374122 179.625878,134 191.5,134 C203.374122,134 213,124.374122 213,112.5 C213,100.625878 203.374122,91 191.5,91 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-2)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-Copy-2",
    transform: "translate(212.000000, 27.000000) scale(-1, 1) rotate(-360.000000) translate(-212.000000, -27.000000) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-3)",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-Copy-4",
    transform: "translate(49.000000, 88.000000) scale(-1, 1) rotate(-360.000000) translate(-49.000000, -88.000000) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-3)",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-8)",
    opacity: 0.5,
    cx: 193,
    cy: 264.726315,
    rx: 115,
    ry: 9.24395112
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.254,91 L300.746,91 C304.752274,91 308,94.2477264 308,98.254 L308,237.924479 C308,240.595328 305.834849,242.760479 303.164,242.760479 L82.836,242.760479 C80.1651509,242.760479 78,240.595328 78,237.924479 L78,98.254 C78,94.2477264 81.2477264,91 85.254,91 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-9)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    transform: "translate(154.942059, 146.635724) rotate(17.000000) translate(-154.942059, -146.635724) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-12)",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-10)",
    fillRule: "evenodd",
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-Copy-6",
    transform: "translate(124.437854, 191.685624) rotate(17.000000) translate(-124.437854, -191.685624) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-14)",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-10)",
    fillRule: "evenodd",
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    strokeLinecap: "round",
    strokeDasharray: "4.8,9.6",
    transform: "translate(134.917615, 172.175634) rotate(-58.000000) translate(-134.917615, -172.175634) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-16)",
    xlinkHref: "#path-15"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#D9D9D9",
    mask: "url(#mask-17)",
    strokeWidth: 8.4,
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-Copy-7"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-19)",
    xlinkHref: "#path-18"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-10)",
    fillRule: "evenodd",
    xlinkHref: "#path-18"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.836,90.4823641 L303.164,90.4823641 C305.834849,90.4823641 308,92.6475151 308,95.3183641 L308,112.254819 L308,112.254819 L78,112.254819 L78,95.3183641 C78,92.6475151 80.1651509,90.4823641 82.836,90.4823641 Z",
    id: "Rectangle",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D9D9D9",
    x: 168.789474,
    y: 96.5302683,
    width: 133.157895,
    height: 9.67664671,
    rx: 4.836
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-21)",
    xlinkHref: "#path-20"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#575756",
    fillRule: "evenodd",
    xlinkHref: "#path-20"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M346.428655,97.5519972 C346.428655,63.8626275 318.894167,36.5519972 284.928655,36.5519972 C250.963142,36.5519972 223.428655,63.8626275 223.428655,97.5519972",
    id: "Oval",
    stroke: "#575756",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeDasharray: "4.800000190734863,7",
    transform: "translate(284.928655, 67.051997) rotate(-49.000000) translate(-284.928655, -67.051997) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    fill: "#FFFFFF",
    cx: 350,
    cy: 40,
    r: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#62EBB9",
    cx: 110.196507,
    cy: 101.368592,
    rx: 3.61496722,
    ry: 3.62874251
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2CB5D6",
    cx: 99.772862,
    cy: 101.368592,
    rx: 3.61496722,
    ry: 3.62874251
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FF520B",
    cx: 89.3492166,
    cy: 101.683279,
    rx: 3.61496722,
    ry: 3.62874251
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.1,
    fill: "#62EBB9",
    cx: 291.246154,
    cy: 245.213707,
    r: 65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.1,
    fill: "#62EBB9",
    cx: 291.246154,
    cy: 245.213707,
    r: 54
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.2,
    fill: "#62EBB9",
    cx: 291.246154,
    cy: 245.213707,
    rx: 42.2153846,
    ry: 42.2089552
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.25,
    fill: "#62EBB9",
    cx: 291.246154,
    cy: 245.213707,
    rx: 36.1846154,
    ry: 36.1791045
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.964835,199.232364 C267.591953,199.232364 264.857692,201.966625 264.857692,205.339507 L264.857692,283.580445 C264.857692,286.953327 267.591953,289.687588 270.964835,289.687588 L313.035165,289.687588 C316.408047,289.687588 319.142308,286.953327 319.142308,283.580445 L319.142308,205.339507 C319.142308,201.966625 316.408047,199.232364 313.035165,199.232364 L270.964835,199.232364 Z",
    id: "Rectangle",
    stroke: "url(#linearGradient-22)",
    strokeWidth: 1.5,
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    opacity: 0.65,
    fill: "black",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-24)",
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M271.022802,201.927993 L279.041622,201.927993 C280.751208,201.927993 282.349039,202.777523 283.305099,204.194786 L283.733363,204.829644 C284.689422,206.246906 286.287253,207.096437 287.996839,207.096437 L296.003161,207.096437 C297.712747,207.096437 299.310578,206.246906 300.266637,204.829644 L300.694901,204.194786 C301.650961,202.777523 303.248792,201.927993 304.958378,201.927993 L312.977198,201.927993 C314.870746,201.927993 316.405769,203.463017 316.405769,205.356565 L316.405769,283.563388 C316.405769,285.456935 314.870746,286.991959 312.977198,286.991959 L271.022802,286.991959 C269.129254,286.991959 267.594231,285.456935 267.594231,283.563388 L267.594231,205.356565 C267.594231,203.463017 269.129254,201.927993 271.022802,201.927993 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#radialGradient-26)",
    cx: 291.246154,
    cy: 300.713707,
    rx: 48.2461538,
    ry: 3.76865672
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-28)",
    xlinkHref: "#path-27"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-10)",
    fillRule: "evenodd",
    xlinkHref: "#path-27"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    fill: "#00F0B5",
    transform: "translate(89.186540, 223.270477) rotate(-184.000000) translate(-89.186540, -223.270477) ",
    cx: 89.1865398,
    cy: 223.270477,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-8",
    fill: "#00F0B5",
    transform: "translate(116.000000, 134.000000) rotate(-184.000000) translate(-116.000000, -134.000000) ",
    cx: 116,
    cy: 134,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-13",
    fill: "#00F5B1",
    transform: "translate(280.000000, 279.000000) rotate(-184.000000) translate(-280.000000, -279.000000) ",
    cx: 280,
    cy: 279,
    r: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.1033241,
    y1: 220.972605,
    x2: 153.384971,
    y2: 276.452299,
    id: "Path-4",
    stroke: "#00F0B5",
    strokeWidth: 2,
    transform: "translate(122.125783, 248.601963) rotate(-184.000000) translate(-122.125783, -248.601963) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.9542658,
    y1: 43.2370815,
    x2: 112.669026,
    y2: 134.929996,
    id: "Path-4-Copy-2",
    stroke: "#00F0B5",
    strokeWidth: 2,
    transform: "translate(86.909838, 89.079660) rotate(-184.000000) translate(-86.909838, -89.079660) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 277.732721,
    y1: 283.356061,
    x2: 166.005547,
    y2: 275.543336,
    id: "Path-4-Copy",
    stroke: "#00F0B5",
    strokeWidth: 2,
    transform: "translate(222.000000, 279.500000) rotate(-184.000000) translate(-222.000000, -279.500000) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#575756",
    transform: "translate(278.000000, 143.000000) rotate(-49.000000) translate(-278.000000, -143.000000) ",
    cx: 278,
    cy: 143,
    r: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    strokeLinecap: "round",
    strokeDasharray: "4.8,9.6",
    transform: "translate(248.443463, 206.797645) rotate(38.000000) translate(-248.443463, -206.797645) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-30)",
    xlinkHref: "#path-29"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#D9D9D9",
    mask: "url(#mask-31)",
    strokeWidth: 9.6,
    xlinkHref: "#path-29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-12"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-33)",
    xlinkHref: "#path-32"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#62EBB9",
    fillRule: "evenodd",
    xlinkHref: "#path-32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-14"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-35)",
    xlinkHref: "#path-34"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#62EBB9",
    fillRule: "evenodd",
    xlinkHref: "#path-34"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M157,287 L148.41,278.756238 C147.662667,278.039027 147.638247,276.85178 148.355458,276.104446 C148.373263,276.085894 148.391447,276.067709 148.41,276.049904 C149.198234,275.293442 150.442597,275.292575 151.231884,276.047938 L157,281.568138 L157,281.568138 L170.765197,268.357777 C171.555029,267.59978 172.802849,267.601983 173.59,268.362764 C174.339979,269.087618 174.360347,270.283207 173.635493,271.033186 C173.619043,271.050206 173.602275,271.066915 173.585197,271.083304 L157,287 L157,287 Z",
    id: "Path-Copy-2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7142857,48 L50.8057143,43.0537428 C50.3597372,42.6043418 50.3597372,41.8793435 50.8057143,41.4299424 C51.247924,40.9843377 51.9676398,40.9815854 52.4132446,41.4237951 C52.4149264,41.4254641 52.416603,41.4271384 52.4182744,41.4288179 L55.7142857,44.7408829 L55.7142857,44.7408829 L63.5799731,36.8148064 C64.0215839,36.3698051 64.7403251,36.3670565 65.1853264,36.8086674 C65.1883296,36.8116476 65.1913161,36.8146447 65.1942857,36.8176583 C65.6407193,37.27071 65.6394333,37.9986517 65.1914017,38.4501231 L55.7142857,48 L55.7142857,48 Z",
    id: "Path-Copy-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-Copy-8",
    transform: "translate(333.500000, 85.500000) scale(-1, -1) rotate(-180.000000) translate(-333.500000, -85.500000) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-36)",
    fillRule: "evenodd",
    xlinkHref: "#path-37"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-38)",
    xlinkHref: "#path-37"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404IllustrationXs);
export default __webpack_public_path__ + "static/media/404-illustration-xs.8dfba939b5768fed28e4bd9910900405.svg";
export { ForwardRef as ReactComponent };